/**
 * @fileoverview デバイスドライバーのダウンロード方法ページ
 */
import { Step } from "../components/Step";
import { useTranslation } from "react-i18next";
import LinkList from "../components/LinkList";
import USBDLJ01 from "./img/deviceDriverDownloadButton.png";
import USBDLJ02 from "./img/downloadDriver2J.png";
import USBDLJ03 from "./img/extractAllDriverJ.png";
import USBDLJ04 from "./img/extractAllDriverJ2.png";
import USBDLJ05 from "./img/extractAllDriverJ3.png";
import USBDLE01 from "./img/English/usbDownloadPage.png";
import USBDLE02 from "./img/English/downloadDriver.png";
import USBDLE03 from "./img/English/ExtractAll.png";
import USBDLE04 from "./img/English/extractFolder.png";
import USBDLE05 from "./img/English/ExtractEnd.png";
import USBDLK01 from "./img/Korean/driverDownloadPageK.png";
import USBDLK02 from "./img/Korean/dlDriverK02.png";
import USBDLK03 from "./img/Korean/dlDriverK03.png";
import USBDLK04 from "./img/Korean/dlDriverK04.png";
import USBDLK05 from "./img/Korean/dlDriverK05.png";

/**
 * デバイスドライバーのダウンロード方法のコンポーネント
 * @returns {JSX.Element} デバイスドライバーのダウンロード方法の JSX element
 */
export const HowToDownloadDeviceDriver: React.FC = () => {
  const { t, i18n } = useTranslation();

  // 画像の設定
  const images = {
    ja: {
      USBDL01: USBDLJ01,
      USBDL02: USBDLJ02,
      USBDL03: USBDLJ03,
      USBDL04: USBDLJ04,
      USBDL05: USBDLJ05,
    },
    en: {
      USBDL01: USBDLE01,
      USBDL02: USBDLE02,
      USBDL03: USBDLE03,
      USBDL04: USBDLE04,
      USBDL05: USBDLE05,
    },
    ko: {
      USBDL01: USBDLK01,
      USBDL02: USBDLK02,
      USBDL03: USBDLK03,
      USBDL04: USBDLK04,
      USBDL05: USBDLK05,
    },
  };

  //現在の言語に基づいて画像決定
  const currentImages =
    i18n.language === "ja"
      ? images.ja
      : i18n.language === "ko"
      ? images.ko
      : images.en;

  /**
   * ダウンロード手順
   */
  const steps_extract = [
    {
      step: "1.",
      text: t(
        "[GHS-8ATデバイスドライバー]ボタンをクリックすると，ダウンロードを開始します。"
      ),
      image: currentImages.USBDL01,
      alt: t("ダウンロードボタン"),
      point_text: (
        <p className="u-font-red">
          <b>
            {t(
              "必ず一度ファイルを保存してからインストールを実行してください。"
            )}
            {t(
              "ダウンロード時に[開く]ボタンを押すと正しくインストールが行われない場合があります。"
            )}
          </b>
        </p>
      ),
    },

    {
      step: "2.",
      text: (
        <>
          {t("ダウンロードが完了すると以下の画面が表示されます。")}
          {t("[フォルダーに表示]ボタンをクリックしてください。")}
        </>
      ),
      image: currentImages.USBDL02,
      alt: t("フォルダーに表示"),
    },

    {
      step: "3.",
      text: (
        <>
          {t(
            "ダウンロードしたファイルを右クリックし，[すべて展開]をクリックします。"
          )}
        </>
      ),
      image: currentImages.USBDL03,
      alt: t("展開"),
    },

    {
      step: "4.",
      text: (
        <>
          {t(
            "展開したフォルダを置きたい場所を選んで，[展開]をクリックします。"
          )}
        </>
      ),
      image: currentImages.USBDL04,
      alt: t("展開場所の選択"),
    },

    {
      step: "5.",
      text: (
        <>
          {t("展開が完了するとデバイスドライバーのフォルダーが表示されます。")}
          {t(
            "USBDriversフォルダーをGHS-8ATを接続したいパソコンにコピーします。"
          )}
        </>
      ),
      image: currentImages.USBDL05,
      alt: t("展開完了"),
    },
  ];

  /**
   * リンクリスト
   */
  const items = [
    {
      to: "/anasys/HowToInstallDeviceDriver",
      text: t("デバイスドライバーのインストール方法"),
    },
  ];

  return (
    <>
      <h2 className="p-heading-2">
        {t("デバイスドライバーのダウンロード方法")}
      </h2>

      <h3 className="p-heading-3">{t("ダウンロード手順")}</h3>
      {steps_extract.map((step, index) => (
        <Step
          key={index}
          step={step.step}
          text={step.text}
          image={step.image}
        />
      ))}

      <h3 className="p-heading-3">
        {t("対象のパソコンにドライバーをインストールする")}
      </h3>
      <p className="c-text">
        {t(
          "解凍した[USBDrivers]のフォルダを対象のパソコンの任意の場所にコピーします。"
        )}
        <br />
        {t("インストールの手順は以下のリンクを参照してください。")}
        {t(
          "ドライバーの指定先はコピーした[USBDrivers]のフォルダを指定します。"
        )}
      </p>
      <LinkList items={items} />
    </>
  );
};
